"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7448],{

/***/ 87448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ KlineChart; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var src = __webpack_require__(65208);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(25349);
// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js + 28 modules
var index_client = __webpack_require__(16329);
// EXTERNAL MODULE: ./node_modules/pako/dist/pako.esm.mjs
var pako_esm = __webpack_require__(27885);
;// CONCATENATED MODULE: ./node_modules/isomorphic-ws/browser.js
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js

var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else if (typeof __webpack_require__.g !== 'undefined') {
  ws = __webpack_require__.g.WebSocket || __webpack_require__.g.MozWebSocket
} else if (typeof window !== 'undefined') {
  ws = window.WebSocket || window.MozWebSocket
} else if (typeof self !== 'undefined') {
  ws = self.WebSocket || self.MozWebSocket
}

/* harmony default export */ var browser = (ws);

;// CONCATENATED MODULE: ./src/socket/cfws.js
/* eslint-disable */ 

// const WebSocket = require('isomorphic-ws');
function CFClient(opts) {
    if (!opts) {
        opts = {};
    }
    this.WebSocket = opts.WebSocket;
    this.env = opts.env ? opts.env : "local";
    this.api_env = opts.api_env;
    this.debug = !!opts.debug;
    this.uri = opts.uri;
    this.requestMaps = {};
    this.listeners = {};
    this.timer = null;
    this.listenerId = 0;
    this.readyed = false;
    this.readyCallbacks = [];
    this.autoReconnect = true;
    this.reconnectTime = 1000;
    this.subscribes = [];
    this.userListeners = [];
    this.connect();
}
CFClient.prototype.connect = function() {
    var me = this;
    this.ws = new browser(this.uri);
    this.ws.onopen = function(evt) {
        me.ws.send('{"type":"handshake", "version":"1.1"}');
    };
    this.ws.binaryType = "arraybuffer";
    this.ws.onmessage = function(evt) {
        me.onmessage(evt);
    };
    this.ws.onclose = function(evt) {
        me.onclose(evt);
    };
};
CFClient.prototype.onmessage = function(evt) {
    // let msg = ungzip(evt.data, { to: 'string' })
    var msg = JSON.parse(evt.data);
    // console.log(evt, 'onmessage-evt', msg)
    if (msg.type == "handshake") {
        var interval = msg.data.heartbeat.interval;
        this.heartbeat(interval);
        this.readyed = true;
        this.reconnectTime = 1000;
        var subscribes = this.subscribes.concat();
        this.subscribes = [];
        this.resubscribe(subscribes);
        var userListeners = this.userListeners.concat();
        this.userListeners = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = userListeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ul = _step.value;
                this.addListener(ul.channel, ul.callback);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (this.readyCallbacks && this.readyCallbacks.length > 0) {
            for(var i in this.readyCallbacks){
                this.readyCallbacks[i] && this.readyCallbacks[i].call(this, this);
            }
        }
        this.readyCallbacks = [];
    } else if (msg.type == "response") {
        if (this.requestMaps[msg.id]) {
            var callback = this.requestMaps[msg.id];
            delete this.requestMaps[msg.id];
            callback(msg.error, msg.data);
        }
    } else if (msg.type == "push") {
        if (this.listeners[msg.channel]) {
            var listeners = this.listeners[msg.channel];
            // console.log(listeners, 'listeners');
            for(var li in listeners){
                // console.log('listeners[li] is ', listeners[li], listeners[li].callback);
                listeners[li].callback && listeners[li].callback(msg.data);
            }
        }
    }
};
CFClient.prototype.resubscribe = function(subscribes) {
    if (subscribes.length > 20) {
        subscribes = [];
    }
    if (subscribes.length > 0) {
        var sub = subscribes.shift();
        this.subscribe(sub.channel, sub.params, sub.callback);
        var me = this;
        setTimeout(function() {
            me.resubscribe(subscribes);
        }, 100);
    }
};
CFClient.prototype.onclose = function(evt) {
    console.log("Connection closed.");
    if (this.timer != null) {
        clearInterval(this.timer);
        this.timer = null;
    }
    this.listeners = {};
    var me = this;
    console.log("will connect after " + me.reconnectTime + " seconds");
    setTimeout(function() {
        if (me.autoReconnect) {
            if (me.reconnectTime < 5000) {
                me.reconnectTime += 1000;
            }
            me.connect();
        }
    }, me.reconnectTime);
};
CFClient.prototype.close = function() {
    this.autoReconnect = false;
    this.ws.close();
};
CFClient.prototype.heartbeat = function(interval) {
    var me = this;
    this.timer = setInterval(function() {
        me.ws.send('{"type":"heartbeat"}');
    }, interval * 1000);
};
CFClient.prototype.request = function(route, params, callback) {
    // console.log(route, params, callback, 'request');
    if (typeof params == "function") {
        callback = params;
        params = null;
    }
    var requestId = Math.floor(Math.random() * 89999999) + 10000000;
    //console.log(requestId)
    if (typeof callback == "function") {
        this.requestMaps[requestId] = callback;
    }
    var request = {
        type: "request",
        id: requestId,
        route: route,
        params: params
    };
    this.ws.send(JSON.stringify(request));
// sessionStorage.setItem("requestEndTime", route);
};
CFClient.prototype.subscribe = function(channel, params, callback) {
    if (typeof params == "function") {
        callback = params;
        params = null;
    }
    if (typeof callback == "function") {
        this.addListener(channel, callback, true);
    }
    var request = {
        type: "subscribe",
        channel: channel
    };
    if (params) {
        request.params = params;
    }
    this.subscribes.push({
        channel: channel,
        params: params,
        callback: callback
    });
    this.ws.send(JSON.stringify(request));
};
CFClient.prototype.unsubscribe = function(channel, params) {
    var request = {
        type: "unsubscribe",
        channel: channel
    };
    if (params) {
        request.params = params;
    }
    this.ws.send(JSON.stringify(request));
    this.removeListeners(channel);
    if (channel == "*") {
        this.subscribes = [];
    } else {
        for(var i in this.subscribes){
            var sub = this.subscribes[i];
            if (sub.channel == channel) {
                //check params ?
                this.subscribes.splice(i, 1);
                break;
            }
        }
    }
};
CFClient.prototype.addListener = function(channel, callback) {
    var autoListen = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!channel || typeof callback != "function") {
        return;
    }
    this.listenerId++;
    if (typeof this.listeners[channel] == "undefined") {
        this.listeners[channel] = [];
    }
    if (!autoListen) {
        this.userListeners.push({
            channel: channel,
            callback: callback
        });
    }
    var listeners = this.listeners[channel];
    listeners.push({
        id: this.listenerId,
        callback: callback
    });
    return this.listenerId;
};
CFClient.prototype.removeListener = function(listenerId) {
    for(var event in this.listeners){
        for(var idx in this.listeners[event]){
            if (this.listeners[event][idx].id == listenerId) {
                this.listeners[event].splice(idx, 1);
                return;
            }
        }
    }
};
CFClient.prototype.removeListeners = function(event) {
    if (event == null || typeof event == "undefined" || event == "*") {
        this.listeners = {};
    } else if (typeof this.listeners[event] != "undefined") {
        delete this.listeners[event];
    }
};
CFClient.prototype.ready = function(callback) {
    if (typeof callback == "function") {
        if (this.readyed) {
            callback.call(this, this);
        } else {
            this.readyCallbacks.push(callback);
        }
    }
};
// if (typeof module != 'undefined' && module.exports) {
//   module.exports = CFClient
// }
/* harmony default export */ var cfws = (CFClient);

;// CONCATENATED MODULE: ./src/socket/index.js
/* eslint-disable */ 

var env = "production";
var uri = "wss://api.noahark.io/aws";
var BASE_URL = "api.noahark.io";
if (true) {
    BASE_URL =  true ? window.location.hostname : 0;
}
uri = "wss://" + BASE_URL + "/aws";
if (false) {}
console.log("wss-URL", uri);
// let uri = ''
// console.log('env', env)
// if (chainId === 15557) {
//   if (process.env.NODE_ENV === 'development') {
//     uri = 'ws://192.168.50.2:10078'
//   } else {
//     uri = 'wss://testapi.noahark.pro/aws'
//   }
// } else {
//   uri = 'wss://api.noahark.pro/aws'
// }
// if (reinitializePageRef.current === true) {
// if(env === 'development'){
//   uri = 'wss://testapi.noahark.pro/aws'
// } else {
//   uri = 'wss://api.noahark.pro/aws'
// }
var client = new cfws({
    env: env,
    uri: uri,
    debug: false
});
var Io = {
    lastSubscribe: null,
    subscribeCallback: null,
    // k线图部分
    // cfwsKline: function (client, params, type = 'hour', subscribe, callback) {
    cfwsKline: function cfwsKline(params, subscribe, callback) {
        var me = this;
        var resolution = params.resolution;
        delete params.resolution;
        client.ready(function() {
            var type = "hour";
            if (resolution == "5") {
                type = "minute5";
            } else if (resolution == "15") {
                type = "minute15";
            } else if (resolution == "30") {
                type = "minute30";
            } else if (resolution == "60") {
                type = "hour";
            } else if (resolution == "240") {
                type = "hour4";
            } else if (resolution == "1D") {
                type = "day";
            } else if (resolution == "1W") {
                type = "week";
            } else if (resolution == "1M") {
                type = "month";
            }
            var wsCallback = function wsCallback(data) {
                var res = {
                    resolution: resolution,
                    symbol: params.symbol,
                    klines: []
                };
                if (data.length > 0) {
                    data.forEach(function(e) {
                        res.klines.push({
                            // date: me.dataFormat(e[0]),
                            // open: e[1],
                            // close: e[2],
                            // high: e[3],
                            // low: e[4],
                            open: e[1],
                            close: e[2],
                            high: e[3],
                            low: e[4],
                            time: e[0] * 1000,
                            volume: Number(e[5].toFixed(0))
                        });
                    });
                }
                callback(res, "all");
                res.klines = [];
            };
            // params.symbol = params.symbol.toLowerCase();
            delete params.symbol;
            //请求k线数据
            client.request("kline." + type, params, function(err, data) {
                if (err) {
                    return;
                }
                // console.log('原始数据', data)
                wsCallback(data);
            });
            if (!subscribe) return;
            // console.log(11111)
            client.subscribe("kline.".concat(type, ".").concat(params.pairId), params, function(data) {
                var item = {
                    close: data.close,
                    // date: me.dataFormat(data.id),
                    high: data.high,
                    low: data.low,
                    open: data.open,
                    time: data.id * 1000,
                    volume: Number(data.amount.toFixed(0))
                };
                var res = {
                    resolution: resolution,
                    symbol: params.symbol,
                    klines: [
                        item
                    ]
                };
                // console.log(data, '更新订阅')
                callback(res, "one");
            });
        });
    },
    // 取消交易对所有推送
    cfwsUnsubscribe: function cfwsUnsubscribe(client, params) {
        var unscribe = "*";
        client.ready(function() {
            if (params) {
                unscribe = params.toLowerCase();
            }
            client.unsubscribe(unscribe);
        });
    },
    // 时间戳转换
    // dataFormat(fdata) {
    //   return moment.unix(fdata).format("YYYY-MM-DD HH:mm:ss")
    // },
    // 交易中心 头部信息
    cfwsHeard: function cfwsHeard(params, callback) {
        // const poolMarketInfo = JSON.parse(sessionStorage.getItem('marketIdAndIndex'))
        var symbol = params.symbol;
        client.ready(function() {
            client.subscribe("ticker.".concat(symbol), function(data) {
                // if (poolMarketInfo && poolMarketInfo.pairId == "35" && poolMarketInfo.coinIndex === "USN" && !data.isChange) {
                //   const e1 = data.open
                //   const e2 = data.close
                //   const e3 = data.high
                //   const e4 = data.low
                //   const e5 = data.price
                //   data.isChange = true
                //   data.open = accDiv(1, e1)
                //   data.close = accDiv(1, e2)
                //   data.high = accDiv(1, e4)
                //   data.low = accDiv(1, e3)
                //   data.price = accDiv(1, e5)
                //   data.amount = Number(accDiv(data.amount, e2))
                // }
                callback(data);
            });
        });
    },
    // testclient.subscribe
    subscribe: function subscribe(channel, params, callback) {
        client.ready(function() {
            client.subscribe(channel, params, callback);
        });
    },
    unsubscribe: function unsubscribe(channel, params) {
        client.ready(function() {
            client.unsubscribe(channel, params);
        });
    }
};
/* harmony default export */ var socket = (Io);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./public/static/charting_library/charting_library.esm.js






function t(e, n) {
    var i = (0,_object_spread/* default */.Z)({}, e);
    for(var _$o in n)"object" != typeof e[_$o] || null === e[_$o] || Array.isArray(e[_$o]) ? void 0 !== n[_$o] && (i[_$o] = n[_$o]) : i[_$o] = t(e[_$o], n[_$o]);
    return i;
}
var e = {
    width: 800,
    height: 500,
    interval: "1D",
    timezone: "Etc/UTC",
    container: "",
    library_path: "",
    locale: "en",
    widgetbar: {
        details: !1,
        watchlist: !1,
        news: !1,
        datawindow: !1,
        watchlist_settings: {
            default_symbols: []
        }
    },
    overrides: {
        "mainSeriesProperties.showCountdown": !1
    },
    studies_overrides: {},
    trading_customization: {
        position: {},
        order: {}
    },
    brokerConfig: {
        configFlags: {}
    },
    fullscreen: !1,
    autosize: !1,
    disabled_features: [],
    enabled_features: [],
    debug: !1,
    logo: {},
    time_frames: [
        {
            text: "5y",
            resolution: "1W"
        },
        {
            text: "1y",
            resolution: "1W"
        },
        {
            text: "6m",
            resolution: "120"
        },
        {
            text: "3m",
            resolution: "60"
        },
        {
            text: "1m",
            resolution: "30"
        },
        {
            text: "5d",
            resolution: "5"
        },
        {
            text: "1d",
            resolution: "1"
        }, 
    ],
    client_id: "0",
    user_id: "0",
    charts_storage_api_version: "1.0",
    favorites: {
        intervals: [],
        chartTypes: [],
        indicators: [],
        drawingTools: []
    }
}, n = JSON.parse('[{"iso":"ar","dir":"rtl","language":"ar"},{"iso":"pt","dir":"ltr","language":"pt"},{"iso":"ca","dir":"ltr","language":"ca_ES"},{"iso":"cs","dir":"ltr","language":"cs"},{"iso":"de","dir":"ltr","language":"de"},{"iso":"en","dir":"ltr","language":"en"},{"iso":"es","dir":"ltr","language":"es"},{"iso":"fa","dir":"rtl","language":"fa"},{"iso":"fr","dir":"ltr","language":"fr"},{"iso":"he","dir":"rtl","language":"he_IL"},{"iso":"hu","dir":"ltr","language":"hu_HU"},{"iso":"id","dir":"ltr","language":"id_ID"},{"iso":"en","dir":"ltr","language":"en"},{"iso":"it","dir":"ltr","language":"it"},{"iso":"ja","dir":"ltr","language":"ja"},{"iso":"ko","dir":"ltr","language":"ko"},{"iso":"ms","dir":"ltr","language":"ms_MY"},{"iso":"pl","dir":"ltr","language":"pl"},{"iso":"ru","dir":"ltr","language":"ru"},{"iso":"sv","dir":"ltr","language":"sv"},{"iso":"th","dir":"ltr","language":"th"},{"iso":"tr","dir":"ltr","language":"tr"},{"iso":"vi","dir":"ltr","language":"vi"},{"iso":"zh-Hans","dir":"ltr","language":"zh"},{"iso":"zh-Hant","dir":"ltr","language":"zh_TW"},{"iso":"el","dir":"ltr","language":"el"},{"iso":"nl","dir":"ltr","language":"nl_NL"},{"iso":"ro","dir":"ltr","language":"ro"}]');
var i = !1;
function o() {
    return "CL v26.001 (internal id 04caa94e @ 2023-08-09T11:45:15.021Z)";
}
var s = /*#__PURE__*/ function() {
    "use strict";
    function s(n) {
        (0,_class_call_check/* default */.Z)(this, s);
        var _$o, _$s;
        if (this._id = "tradingview_".concat((1048576 * (1 + Math.random()) | 0).toString(16).substring(1)), this._ready = !1, this._readyHandlers = [], this._onWindowResize = this._autoResizeChart.bind(this), !n.datafeed) throw new Error("Datafeed is not defined");
        (null === (_$o = n.overrides) || void 0 === _$o ? void 0 : _$o["mainSeriesProperties.priceAxisProperties.lockScale"]) && (console.warn("mainSeriesProperties.priceAxisProperties.lockScale can not be set to true within the widget constructor"), delete n.overrides["mainSeriesProperties.priceAxisProperties.lockScale"]), this._options = t(e, n);
        "dark" === (null !== (_$s = this._options.theme) && void 0 !== _$s ? _$s : "light").toLowerCase() && void 0 === this._options.loading_screen && (this._options.loading_screen = {
            backgroundColor: "#131722"
        }), this._options.debug && (i || (i = !0, console.log("Using CL v26.001 (internal id 04caa94e @ 2023-08-09T11:45:15.021Z)"))), this._create();
    }
    (0,_create_class/* default */.Z)(s, [
        {
            key: "setDebugMode",
            value: function setDebugMode(t) {
                this._innerAPI().setDebugMode(t);
            }
        },
        {
            key: "onChartReady",
            value: function onChartReady(t) {
                this._ready ? t.call(this) : this._readyHandlers.push(t);
            }
        },
        {
            key: "headerReady",
            value: function headerReady() {
                var _this = this;
                return this._innerWindowLoaded.then(function() {
                    return _this._innerWindow().headerReady();
                });
            }
        },
        {
            key: "onGrayedObjectClicked",
            value: function onGrayedObjectClicked(t) {
                this._doWhenInnerApiLoaded(function(e) {
                    e.onGrayedObjectClicked(t);
                });
            }
        },
        {
            key: "onShortcut",
            value: function onShortcut(t, e) {
                this._doWhenInnerWindowLoaded(function(n) {
                    n.createShortcutAction(t, e);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(t, e) {
                this._doWhenInnerApiLoaded(function(n) {
                    n.subscribe(t, e);
                });
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(t, e) {
                this._doWhenInnerApiLoaded(function(n) {
                    n.unsubscribe(t, e);
                });
            }
        },
        {
            key: "chart",
            value: function chart(t) {
                return this._innerAPI().chart(t);
            }
        },
        {
            key: "getLanguage",
            value: function getLanguage() {
                return this._options.locale;
            }
        },
        {
            key: "setSymbol",
            value: function setSymbol(t, e, n) {
                this._innerAPI().changeSymbol(t, e, n);
            }
        },
        {
            key: "remove",
            value: function remove() {
                window.removeEventListener("resize", this._onWindowResize), this._readyHandlers.splice(0, this._readyHandlers.length), delete window[this._id], this._iFrame.parentNode && this._iFrame.parentNode.removeChild(this._iFrame);
            }
        },
        {
            key: "closePopupsAndDialogs",
            value: function closePopupsAndDialogs() {
                this._doWhenInnerApiLoaded(function(t) {
                    t.closePopupsAndDialogs();
                });
            }
        },
        {
            key: "selectLineTool",
            value: function selectLineTool(t, e) {
                this._innerAPI().selectLineTool(t, e);
            }
        },
        {
            key: "selectedLineTool",
            value: function selectedLineTool() {
                return this._innerAPI().selectedLineTool();
            }
        },
        {
            key: "save",
            value: function save(t) {
                this._innerAPI().saveChart(t);
            }
        },
        {
            key: "load",
            value: function load(t, e) {
                this._innerAPI().loadChart({
                    json: t,
                    extendedData: e
                });
            }
        },
        {
            key: "getSavedCharts",
            value: function getSavedCharts(t) {
                this._innerAPI().getSavedCharts(t);
            }
        },
        {
            key: "loadChartFromServer",
            value: function loadChartFromServer(t) {
                this._innerAPI().loadChartFromServer(t);
            }
        },
        {
            key: "saveChartToServer",
            value: function saveChartToServer(t, e, n) {
                this._innerAPI().saveChartToServer(t, e, n);
            }
        },
        {
            key: "removeChartFromServer",
            value: function removeChartFromServer(t, e) {
                this._innerAPI().removeChartFromServer(t, e);
            }
        },
        {
            key: "onContextMenu",
            value: function onContextMenu(t) {
                this._doWhenInnerApiLoaded(function(e) {
                    e.onContextMenu(t);
                });
            }
        },
        {
            key: "createButton",
            value: function createButton(t) {
                return this._innerWindow().createButton(t);
            }
        },
        {
            key: "createDropdown",
            value: function createDropdown(t) {
                return this._innerWindow().createDropdown(t);
            }
        },
        {
            key: "showNoticeDialog",
            value: function showNoticeDialog(t) {
                this._doWhenInnerApiLoaded(function(e) {
                    e.showNoticeDialog(t);
                });
            }
        },
        {
            key: "showConfirmDialog",
            value: function showConfirmDialog(t) {
                this._doWhenInnerApiLoaded(function(e) {
                    e.showConfirmDialog(t);
                });
            }
        },
        {
            key: "showLoadChartDialog",
            value: function showLoadChartDialog() {
                this._innerAPI().showLoadChartDialog();
            }
        },
        {
            key: "showSaveAsChartDialog",
            value: function showSaveAsChartDialog() {
                this._innerAPI().showSaveAsChartDialog();
            }
        },
        {
            key: "symbolInterval",
            value: function symbolInterval() {
                return this._innerAPI().getSymbolInterval();
            }
        },
        {
            key: "mainSeriesPriceFormatter",
            value: function mainSeriesPriceFormatter() {
                return this._innerAPI().mainSeriesPriceFormatter();
            }
        },
        {
            key: "getIntervals",
            value: function getIntervals() {
                return this._innerAPI().getIntervals();
            }
        },
        {
            key: "getStudiesList",
            value: function getStudiesList() {
                return this._innerAPI().getStudiesList();
            }
        },
        {
            key: "getStudyInputs",
            value: function getStudyInputs(t) {
                return this._innerAPI().getStudyInputs(t);
            }
        },
        {
            key: "getStudyStyles",
            value: function getStudyStyles(t) {
                return this._innerAPI().getStudyStyles(t);
            }
        },
        {
            key: "addCustomCSSFile",
            value: function addCustomCSSFile(t) {
                this._innerWindow().addCustomCSSFile(t);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(e) {
                ;
                this._options = t(this._options, {
                    overrides: e
                }), this._doWhenInnerWindowLoaded(function(t) {
                    t.applyOverrides(e);
                });
            }
        },
        {
            key: "applyStudiesOverrides",
            value: function applyStudiesOverrides(t) {
                this._doWhenInnerWindowLoaded(function(e) {
                    e.applyStudiesOverrides(t);
                });
            }
        },
        {
            key: "watchList",
            value: function watchList() {
                return this._innerAPI().watchlist();
            }
        },
        {
            key: "news",
            value: function news() {
                return this._innerAPI().news();
            }
        },
        {
            key: "widgetbar",
            value: function widgetbar() {
                return this._innerAPI().widgetbar();
            }
        },
        {
            key: "activeChart",
            value: function activeChart() {
                return this._innerAPI().activeChart();
            }
        },
        {
            key: "activeChartIndex",
            value: function activeChartIndex() {
                return this._innerAPI().activeChartIndex();
            }
        },
        {
            key: "setActiveChart",
            value: function setActiveChart(t) {
                return this._innerAPI().setActiveChart(t);
            }
        },
        {
            key: "chartsCount",
            value: function chartsCount() {
                return this._innerAPI().chartsCount();
            }
        },
        {
            key: "layout",
            value: function layout() {
                return this._innerAPI().layout();
            }
        },
        {
            key: "setLayout",
            value: function setLayout(t) {
                this._innerAPI().setLayout(t);
            }
        },
        {
            key: "layoutName",
            value: function layoutName() {
                return this._innerAPI().layoutName();
            }
        },
        {
            key: "changeTheme",
            value: function changeTheme(t, e) {
                return this._innerWindow().changeTheme(t, e);
            }
        },
        {
            key: "getTheme",
            value: function getTheme() {
                return this._innerWindow().getTheme();
            }
        },
        {
            key: "takeScreenshot",
            value: function takeScreenshot() {
                this._doWhenInnerApiLoaded(function(t) {
                    t.takeScreenshot();
                });
            }
        },
        {
            key: "lockAllDrawingTools",
            value: function lockAllDrawingTools() {
                return this._innerAPI().lockAllDrawingTools();
            }
        },
        {
            key: "hideAllDrawingTools",
            value: function hideAllDrawingTools() {
                return this._innerAPI().hideAllDrawingTools();
            }
        },
        {
            key: "drawOnAllCharts",
            value: function drawOnAllCharts(t) {
                this._innerAPI().drawOnAllCharts(t);
            }
        },
        {
            key: "magnetEnabled",
            value: function magnetEnabled() {
                return this._innerAPI().magnetEnabled();
            }
        },
        {
            key: "magnetMode",
            value: function magnetMode() {
                return this._innerAPI().magnetMode();
            }
        },
        {
            key: "undoRedoState",
            value: function undoRedoState() {
                return this._innerAPI().undoRedoState();
            }
        },
        {
            key: "setIntervalLinkingEnabled",
            value: function setIntervalLinkingEnabled(t) {
                this._innerAPI().setIntervalLinkingEnabled(t);
            }
        },
        {
            key: "setTimeFrame",
            value: function setTimeFrame(t) {
                this._innerAPI().setTimeFrame(t);
            }
        },
        {
            key: "symbolSync",
            value: function symbolSync() {
                return this._innerAPI().symbolSync();
            }
        },
        {
            key: "intervalSync",
            value: function intervalSync() {
                return this._innerAPI().intervalSync();
            }
        },
        {
            key: "crosshairSync",
            value: function crosshairSync() {
                return this._innerAPI().crosshairSync();
            }
        },
        {
            key: "timeSync",
            value: function timeSync() {
                return this._innerAPI().timeSync();
            }
        },
        {
            key: "dateRangeSync",
            value: function dateRangeSync() {
                return this._innerAPI().dateRangeSync();
            }
        },
        {
            key: "setFeatureEnabled",
            value: function setFeatureEnabled(t, e) {
                this._innerAPI().setFeatureEnabled(t, e);
            }
        },
        {
            key: "getAllFeatures",
            value: function getAllFeatures() {
                return this._innerWindow().getAllFeatures();
            }
        },
        {
            key: "clearUndoHistory",
            value: function clearUndoHistory() {
                return this._innerAPI().clearUndoHistory();
            }
        },
        {
            key: "undo",
            value: function undo() {
                return this._innerAPI().undo();
            }
        },
        {
            key: "redo",
            value: function redo() {
                return this._innerAPI().redo();
            }
        },
        {
            key: "startFullscreen",
            value: function startFullscreen() {
                this._innerAPI().startFullscreen();
            }
        },
        {
            key: "exitFullscreen",
            value: function exitFullscreen() {
                this._innerAPI().exitFullscreen();
            }
        },
        {
            key: "takeClientScreenshot",
            value: function takeClientScreenshot(t) {
                return this._innerAPI().takeClientScreenshot(t);
            }
        },
        {
            key: "navigationButtonsVisibility",
            value: function navigationButtonsVisibility() {
                return this._innerWindow().getNavigationButtonsVisibility();
            }
        },
        {
            key: "paneButtonsVisibility",
            value: function paneButtonsVisibility() {
                return this._innerWindow().getPaneButtonsVisibility();
            }
        },
        {
            key: "dateFormat",
            value: function dateFormat() {
                return this._innerWindow().getDateFormat();
            }
        },
        {
            key: "timeHoursFormat",
            value: function timeHoursFormat() {
                return this._innerWindow().getTimeHoursFormat();
            }
        },
        {
            key: "currencyAndUnitVisibility",
            value: function currencyAndUnitVisibility() {
                return this._innerWindow().getCurrencyAndUnitVisibility();
            }
        },
        {
            key: "supportedChartTypes",
            value: function supportedChartTypes() {
                return this._innerAPI().supportedChartTypes();
            }
        },
        {
            key: "watermark",
            value: function watermark() {
                return this._innerAPI().watermark();
            }
        },
        {
            key: "customSymbolStatus",
            value: function customSymbolStatus() {
                return this._innerWindow().customSymbolStatus();
            }
        },
        {
            key: "setCSSCustomProperty",
            value: function setCSSCustomProperty(t, e) {
                if (!1 === t.startsWith("--")) throw new Error("customPropertyName should begin with a double hyphen");
                this._innerWindow().document.body.style.setProperty(t, e);
            }
        },
        {
            key: "getCSSCustomPropertyValue",
            value: function getCSSCustomPropertyValue(t) {
                if (!1 === t.startsWith("--")) throw new Error("customPropertyName should begin with a double hyphen");
                var e = this._innerWindow().document.body, n = e.style.getPropertyValue(t);
                if (n) return n;
                return getComputedStyle(e).getPropertyValue(t);
            }
        },
        {
            key: "linking",
            value: function linking() {
                return this._innerAPI().linking;
            }
        },
        {
            key: "_innerAPI",
            value: function _innerAPI() {
                return this._innerWindow().tradingViewApi;
            }
        },
        {
            key: "_innerWindow",
            value: function _innerWindow() {
                return this._iFrame.contentWindow;
            }
        },
        {
            key: "_doWhenInnerWindowLoaded",
            value: function _doWhenInnerWindowLoaded(t) {
                var _this = this;
                this._ready ? t(this._innerWindow()) : this._innerWindowLoaded.then(function() {
                    t(_this._innerWindow());
                });
            }
        },
        {
            key: "_doWhenInnerApiLoaded",
            value: function _doWhenInnerApiLoaded(t) {
                var _this = this;
                this._doWhenInnerWindowLoaded(function(e) {
                    e.doWhenApiIsReady(function() {
                        return t(_this._innerAPI());
                    });
                });
            }
        },
        {
            key: "_autoResizeChart",
            value: function _autoResizeChart() {
                var _this = this;
                this._options.fullscreen && (this._iFrame.style.height = window.innerHeight + "px", r && setTimeout(function() {
                    _this._iFrame.style.height = window.innerHeight + "px";
                }, 30));
            }
        },
        {
            key: "_create",
            value: function _create() {
                var _this = this;
                var t, e;
                var n = null !== (e = null === (t = this._options.enabled_features) || void 0 === t ? void 0 : t.includes("iframe_loading_compatibility_mode")) && void 0 !== e && e, ref = (0,_sliced_to_array/* default */.Z)(this._render(!n), 2), i = ref[0], _$o = ref[1], _$s = this._options.container, r = "string" == typeof _$s ? document.getElementById(_$s) : _$s;
                if (null === r) throw new Error("There is no such element - #".concat(this._options.container));
                r.innerHTML = i, this._iFrame = r.querySelector("#".concat(this._id));
                var a = this._iFrame;
                n && (a.contentWindow ? (a.contentWindow.document.open(), a.contentWindow.document.write(_$o), a.contentWindow.document.close()) : console.warn("Unable to locate contentWindow for the created iframe. Please try disabling the `iframe_loading_compatibility_mode` featureset.")), (this._options.autosize || this._options.fullscreen) && (a.style.width = "100%", this._options.fullscreen || (a.style.height = "100%")), window.addEventListener("resize", this._onWindowResize), this._onWindowResize(), this._innerWindowLoaded = new Promise(function(t) {
                    var e = function() {
                        a.removeEventListener("load", e, !1), t();
                    };
                    a.addEventListener("load", e, !1);
                }), this._innerWindowLoaded.then(function() {
                    try {
                        _this._innerWindow().widgetReady(function() {
                            _this._ready = !0;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = _this._readyHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    try {
                                        _$t.call(_this);
                                    } catch (t) {
                                        console.error(t);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            _this._innerWindow().initializationFinished();
                        });
                    } catch (t) {
                        if ((0,_instanceof/* default */.Z)(t, Error) && /widgetReady is not a function/.test(t.message)) throw new Error("There was an error when loading the library. Usually this error means the library failed to load its static files. Check that the library files are available at ".concat(window.location.host, "/").concat(_this._options.library_path || "", " or correct the library_path option."));
                    }
                });
            }
        },
        {
            key: "_render",
            value: function _render(t) {
                var e = window;
                if (e[this._id] = {
                    datafeed: this._options.datafeed,
                    customFormatters: this._options.custom_formatters || this._options.customFormatters,
                    brokerFactory: this._options.broker_factory || this._options.brokerFactory,
                    overrides: this._options.overrides,
                    studiesOverrides: this._options.studies_overrides,
                    tradingCustomization: this._options.trading_customization,
                    disabledFeatures: this._options.disabled_features,
                    enabledFeatures: this._options.enabled_features,
                    brokerConfig: this._options.broker_config || this._options.brokerConfig,
                    restConfig: this._options.restConfig,
                    favorites: this._options.favorites,
                    logo: this._options.logo,
                    numeric_formatting: this._options.numeric_formatting,
                    rss_news_feed: this._options.rss_news_feed,
                    newsProvider: this._options.news_provider,
                    loadLastChart: this._options.load_last_chart,
                    saveLoadAdapter: this._options.save_load_adapter,
                    loading_screen: this._options.loading_screen,
                    settingsAdapter: this._options.settings_adapter,
                    getCustomIndicators: this._options.custom_indicators_getter,
                    additionalSymbolInfoFields: this._options.additional_symbol_info_fields,
                    headerWidgetButtonsMode: this._options.header_widget_buttons_mode,
                    customTranslateFunction: this._options.custom_translate_function,
                    symbolSearchComplete: this._options.symbol_search_complete,
                    contextMenu: this._options.context_menu,
                    settingsOverrides: this._options.settings_overrides,
                    timeframe: this._options.timeframe,
                    customTimezones: this._options.custom_timezones
                }, this._options.saved_data) e[this._id].chartContent = {
                    json: this._options.saved_data
                }, this._options.saved_data_meta_info && (e[this._id].chartContentExtendedData = this._options.saved_data_meta_info);
                else if (!this._options.load_last_chart && !this._options.symbol) throw new Error("Symbol is not defined: either 'symbol' or 'load_last_chart' option must be set");
                if (this._options.library_path && !this._options.library_path.endsWith("/") && console.warn("library_path option should contain a trailing forward slash"), this._options.locale) {
                    var _$t = encodeURIComponent(this._options.locale);
                    n.findIndex(function(e) {
                        return e.language === _$t;
                    }) >= 0 || (console.warn("locale isn't supported. Using default of `en`."), this._options.locale = "en");
                }
                var i = function(t, e) {
                    var i;
                    var _$o = new URL("".concat(t || ""), location.href).href, _$s = JSON.parse('["bundles/runtime.93ba548e6a7994d2a8f1.js","bundles/__LANG__.5008.e5d7d914577969582fa4.js","bundles/3515.2f722d33cebe31a154b1.css","bundles/1564.94d55d014a317059a934.js","bundles/library.0f3decc3cfc32a3eb326.js"]'), r = encodeURIComponent(e), a = null !== (i = n.find(function(t) {
                        return t.language === r;
                    })) && void 0 !== i ? i : {
                        iso: "en",
                        dir: "ltr"
                    }, d = 'lang="'.concat(a.iso, '" dir="').concat(a.dir, '"'), l = "\n".concat(function(t, e, n) {
                        if (void 0 === t) return "";
                        var i = [], _$o = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$s = _step.value;
                                _$s.endsWith(".js") ? i.push('<script defer crossorigin="anonymous" src="'.concat(_$s.replace("__LANG__", n), '"></script>')) : _$s.endsWith(".css") && _$o.push('<link type="text/css" href="'.concat(e ? _$s.replace(/\.css$/i, ".rtl.css") : _$s, '" rel="stylesheet"/>'));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return (0,_to_consumable_array/* default */.Z)(i).concat((0,_to_consumable_array/* default */.Z)(_$o)).join("\n");
                    }(_$s, "rtl" === a.dir, r), "\n");
                    return "<!DOCTYPE html><html ".concat((h = {
                        bundles: l,
                        localeLanguage: r,
                        htmlAttrs: d,
                        libraryPath: _$o
                    }).htmlAttrs, '><head><base href="').concat(h.libraryPath, '"><meta charset="utf-8"><script>window===window.parent&&(location.href="about:blank")</script> ').concat(h.bundles, ' </head><body class="chart-page unselectable on-widget"><div class="loading-indicator" id="loading-indicator"></div><script>var JSServer={},__initialEnabledFeaturesets=["charting_library"]</script><script>(function() {\n		window.urlParams = (function () {\n			var match,\n				pl	 = /\\+/g,  // Regex for replacing addition symbol with a space\n				search = /([^&=]+)=?([^&]*)/g,\n				decode = function (s) { return decodeURIComponent(s.replace(pl, \' \')).replace(/<\\/?[^>]+(>|$)/g, \'\'); },\n				query = function() {\n					// We don\'t use hash on the url because: safari 13 throws an error if you attempt this\n					// on a blob, and safari 14 will strip hash from blob urls.\n					if (frameElement && frameElement.dataset.widgetOptions) {\n						return frameElement.dataset.widgetOptions;\n					} else {\n						throw "Unexpected use of this page";\n					}\n				}(),\n				result = {};\n\n			while (match = search.exec(query)) {\n				result[decode(match[1])] = decode(match[2]);\n			}\n\n			var additionalSettingsObject = window.parent[result.uid];\n\n			var customObjectNames = [\'datafeed\', \'customFormatters\', \'brokerFactory\', \'save_load_adapter\', \'customTranslateFunction\', \'contextMenu\'];\n\n			for (var p in additionalSettingsObject) {\n				if (customObjectNames.indexOf(p) === -1) {\n					result[p] = JSON.stringify(additionalSettingsObject[p]);\n				}\n			}\n\n			return result;\n		})();\n\n		window.locale = urlParams.locale;\n		window.language = urlParams.locale; // a very big attention needed here\n		window.customTranslateFunction = window.parent[urlParams.uid].customTranslateFunction;\n\n		window.addCustomCSSFile = function(href) {\n			var link = document.createElement(\'link\');\n			link.setAttribute(\'type\', \'text/css\');\n			link.setAttribute(\'rel\', \'stylesheet\');\n			link.setAttribute(\'href\', href);\n			link.setAttribute(\'cross-origin\', \'anonymous\');\n\n			window.loadedCustomCss = new Promise((resolve) => {\n				link.onload = resolve;\n				link.onerror = resolve;\n			});\n			document.body.appendChild(link);\n		};\n\n		window.loadedCustomCss = Promise.resolve();\n		if (!!urlParams.customCSS) {\n			window.addCustomCSSFile(urlParams.customCSS);\n		}\n\n		var loadingScreenParams = {};\n\n		if (typeof urlParams.loading_screen === \'string\') {\n			try {\n				loadingScreenParams = JSON.parse(urlParams.loading_screen);\n			} catch(e) {}\n		}\n\n		var loadingIndicatorElement = document.getElementById(\'loading-indicator\');\n\n		if (loadingScreenParams.backgroundColor) {\n			loadingIndicatorElement.style = \'background-color: \' + loadingScreenParams.backgroundColor;\n		}\n\n		!function(){"use strict";var t,e=new WeakMap;!function(t){t[t.Element=1]="Element",t[t.Document=9]="Document"}(t||(t={}));var n={mini:"xsmall",xsmall:"xsmall",small:"small",medium:"medium",large:"large"};var i,s,o,r,l,c=(void 0===l&&(l=""),i=\'<div class="tv-spinner \'.concat(l,\'" role="progressbar"></div>\'),o=function(n,i){var s,o;return s=null==i?document.documentElement:i.nodeType===t.Document?i.documentElement:i,e&&(o=e.get(s)),o||((o=s.ownerDocument.createRange()).selectNodeContents(s),e&&e.set(s,o)),o.createContextualFragment(n)}(i,s),null!==(r=o.firstElementChild)&&o.removeChild(r),r),a=function(){function t(t){this._shown=!1,this._el=c.cloneNode(!0),this.setSize(n[t||"large"])}return t.prototype.spin=function(t){return this._el.classList.add("tv-spinner--shown"),void 0===this._container&&(this._container=t,void 0!==t&&t.appendChild(this._el)),this._shown=!0,this},t.prototype.stop=function(t){return t&&void 0!==this._container&&this._container.removeChild(this._el),this._el&&this._el.classList.remove("tv-spinner--shown"),this._shown=!1,this},t.prototype.setStyle=function(t){var e=this;return Object.keys(t).forEach((function(n){var i=t[n];void 0!==i&&e._el.style.setProperty(n,i)})),this},t.prototype.style=function(){return this._el.style},t.prototype.setSize=function(t){var e=void 0!==t?"tv-spinner--size_".concat(t):"";return this._el.className="tv-spinner ".concat(e," ").concat(this._shown?"tv-spinner--shown":""),this},t.prototype.getEl=function(){return this._el},t.prototype.destroy=function(){this.stop(),delete this._el,delete this._container},t}();window.Spinner=a}();\n\n\n		var spinnerColor = (loadingScreenParams.foregroundColor) ? loadingScreenParams.foregroundColor : undefined;\n\n		var loadingSpinner = new Spinner(\'large\').setStyle({\n			\'--tv-spinner-color\': spinnerColor,\n			zIndex: String(2e9),\n		});\n		loadingSpinner.getEl().classList.add(\'spinner\');\n		loadingSpinner.spin(loadingIndicatorElement);\n	})();</script></body></html>');
                    var h;
                }(this._options.library_path || "", this._options.locale);
                var _$o = new URL("about:blank");
                if (t) {
                    var _$t1 = new Blob([
                        i
                    ], {
                        type: "text/html"
                    }), e1 = URL.createObjectURL(_$t1);
                    _$o = new URL(e1);
                }
                var _$s = "symbol=" + encodeURIComponent(this._options.symbol || "") + "&interval=" + encodeURIComponent(this._options.interval) + (this._options.toolbar_bg ? "&toolbarbg=" + encodeURIComponent(this._options.toolbar_bg.replace("#", "")) : "") + (this._options.studies_access ? "&studiesAccess=" + encodeURIComponent(JSON.stringify(this._options.studies_access)) : "") + "&widgetbar=" + encodeURIComponent(JSON.stringify(this._options.widgetbar)) + (this._options.drawings_access ? "&drawingsAccess=" + encodeURIComponent(JSON.stringify(this._options.drawings_access)) : "") + "&timeFrames=" + encodeURIComponent(JSON.stringify(this._options.time_frames)) + "&locale=" + encodeURIComponent(this._options.locale) + "&uid=" + encodeURIComponent(this._id) + "&clientId=" + encodeURIComponent(String(this._options.client_id)) + "&userId=" + encodeURIComponent(String(this._options.user_id)) + (this._options.charts_storage_url ? "&chartsStorageUrl=" + encodeURIComponent(this._options.charts_storage_url) : "") + (this._options.charts_storage_api_version ? "&chartsStorageVer=" + encodeURIComponent(this._options.charts_storage_api_version) : "") + (this._options.custom_css_url ? "&customCSS=" + encodeURIComponent(this._options.custom_css_url) : "") + (this._options.custom_font_family ? "&customFontFamily=" + encodeURIComponent(this._options.custom_font_family) : "") + (this._options.auto_save_delay ? "&autoSaveDelay=" + encodeURIComponent(String(this._options.auto_save_delay)) : "") + "&debug=" + encodeURIComponent(String(this._options.debug)) + (this._options.snapshot_url ? "&snapshotUrl=" + encodeURIComponent(this._options.snapshot_url) : "") + (this._options.timezone ? "&timezone=" + encodeURIComponent(this._options.timezone) : "") + (this._options.study_count_limit ? "&studyCountLimit=" + encodeURIComponent(String(this._options.study_count_limit)) : "") + (this._options.symbol_search_request_delay ? "&ssreqdelay=" + encodeURIComponent(String(this._options.symbol_search_request_delay)) : "") + (this._options.compare_symbols ? "&compareSymbols=" + encodeURIComponent(JSON.stringify(this._options.compare_symbols)) : "") + (this._options.theme ? "&theme=" + encodeURIComponent(String(this._options.theme)) : "") + (this._options.header_widget_buttons_mode ? "&header_widget_buttons_mode=" + encodeURIComponent(String(this._options.header_widget_buttons_mode)) : "") + (this._options.time_scale ? "&time_scale=" + encodeURIComponent(JSON.stringify(this._options.time_scale)) : "");
                return [
                    '<iframe\n		id="'.concat(this._id, '" name="').concat(this._id, '" src="').concat(_$o.href, '" data-widget-options="').concat(_$s, '"\n		').concat(this._options.autosize || this._options.fullscreen ? "" : 'width="'.concat(this._options.width, '" height="').concat(this._options.height, '"'), ' title="Financial Chart" frameborder="0" allowTransparency="true" scrolling="no" allowfullscreen style="display:block;">\n	</iframe>'),
                    i, 
                ];
            }
        }
    ]);
    return s;
}();
 true && (window.TradingView = window.TradingView || {}, window.TradingView.version = o);
var r = !( false || !window.navigator || !window.navigator.userAgent) && window.navigator.userAgent.includes("CriOS");


;// CONCATENATED MODULE: ./src/tradeView/datafeed.js
/*
	This class implements interaction with UDF-compatible datafeed.
	See UDF protocol reference at
	https://github.com/tradingview/charting_library/wiki/UDF
*/ /* eslint-disable */ 

var Datafeeds = /*#__PURE__*/ function() {
    "use strict";
    function Datafeeds(mgr, updateFrequency) {
        (0,_class_call_check/* default */.Z)(this, Datafeeds);
        this._mgr = mgr;
        this._configuration = undefined;
        this._enableLogging = false;
        this._initializationFinished = false;
        this._callbacks = {};
        this._initialize();
    }
    (0,_create_class/* default */.Z)(Datafeeds, [
        {
            /**
   * 默认配置
   */ key: "defaultConfiguration",
            value: function defaultConfiguration() {
                return {
                    supports_search: true,
                    supports_group_request: false,
                    supported_resolutions: [
                        "5",
                        "15",
                        "30",
                        "60",
                        "240",
                        "1D",
                        "1W",
                        "1M"
                    ],
                    supports_marks: true,
                    supports_timescale_marks: true,
                    supports_time: true,
                    exchanges: [
                        {
                            value: "",
                            name: "All Exchanges",
                            desc: ""
                        }, 
                    ],
                    symbols_types: [
                        {
                            name: "All types",
                            value: ""
                        }, 
                    ]
                };
            }
        },
        {
            /**
   * 获取服务端时间
   * @param {*Function 回调函数} callback
   */ key: "getServerTime",
            value: function getServerTime(callback) {
                if (this._configuration.supports_time) {
                    var self = this;
                    setTimeout(function() {
                        callback(self._mgr.getServerTime());
                    }, 10);
                }
            }
        },
        {
            /**
   * 绑定事件
   * @param {*String 事件名} event
   * @param {*Function 回调函数} callback
   */ key: "on",
            value: function on(event, callback) {
                if (!this._callbacks.hasOwnProperty(event)) {
                    this._callbacks[event] = [];
                }
                this._callbacks[event].push(callback);
                return this;
            }
        },
        {
            /**
   * 运行事件
   * @param {*String 事件名} event
   * @param {*Undefined 参数} argument
   */ key: "_fireEvent",
            value: function _fireEvent(event, argument) {
                if (this._callbacks.hasOwnProperty(event)) {
                    var callbacksChain = this._callbacks[event];
                    for(var i = 0; i < callbacksChain.length; ++i){
                        callbacksChain[i](argument);
                    }
                    this._callbacks[event] = [];
                }
            }
        },
        {
            /**
   * 初始化结束
   */ key: "onInitialized",
            value: function onInitialized() {
                this._initializationFinished = true;
                this._fireEvent("initialized");
            }
        },
        {
            /**
   * 打印信息
   * @param {*String 信息} message
   */ key: "_logMessage",
            value: function _logMessage(message) {
                if (this._enableLogging) {
                    console.log(new Date().toLocaleTimeString() + " >> ", message);
                }
            }
        },
        {
            /**
   * 初始化
   */ key: "_initialize",
            value: function _initialize() {
                var configurationData = this._mgr.getConfig();
                var defaultConfig = this.defaultConfiguration();
                if (configurationData) {
                    var conf = Object.assign({}, defaultConfig, configurationData);
                    this._setupWithConfiguration(conf);
                } else {
                    this._setupWithConfiguration(defaultConfig);
                }
            }
        },
        {
            /**
   * 填充配置数据
   * @param {*Function 回调函数} callback
   */ key: "onReady",
            value: function onReady(callback) {
                var that = this;
                if (this._configuration) {
                    setTimeout(function() {
                        callback(that._configuration);
                    }, 0);
                } else {
                    this.on("configuration_ready", function() {
                        callback(that._configuration);
                    });
                }
            }
        },
        {
            /**
   * 安装配置数据
   * @param {*Object 配置数据} configurationData
   */ key: "_setupWithConfiguration",
            value: function _setupWithConfiguration(configurationData) {
                this._configuration = configurationData;
                if (!this._configuration.exchanges) {
                    this._configuration.exchanges = [];
                }
                if (this._configuration.supports_group_request) {
                    console.error(" >> ：Sorry unsupports group request");
                    return;
                }
                this.onInitialized();
                this._fireEvent("configuration_ready");
                this._logMessage("Initialized with " + JSON.stringify(configurationData));
            }
        },
        {
            /**
   * 通过商品名称解析商品信息
   * @param {*String 商品名称或ticker} symbolName
   * @param {*Function(SymbolInfo)} onSymbolResolvedCallback
   * @param {*Function(reason)} onResolveErrorCallback
   */ key: "resolveSymbol",
            value: function resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback) {
                var onResultReady = function onResultReady(data) {
                    var postProcessedData = data;
                    if (that.postProcessSymbolInfo) {
                        postProcessedData = that.postProcessSymbolInfo(postProcessedData);
                    }
                    that._logMessage("Symbol resolved: " + (Date.now() - resolveRequestStartTime));
                    onSymbolResolvedCallback(postProcessedData);
                };
                var that = this;
                if (!this._initializationFinished) {
                    this.on("initialized", function() {
                        that.resolveSymbol(symbolName, onSymbolResolvedCallback, onResolveErrorCallback);
                    });
                    return;
                }
                var resolveRequestStartTime = Date.now();
                that._logMessage("Resolve requested");
                if (!this._configuration.supports_group_request) {
                    setTimeout(function() {
                        var data = that._mgr.resolveTVSymbol(symbolName ? symbolName.toUpperCase() : "");
                        if (data) {
                            onResultReady(data);
                        } else {
                            that._logMessage("Error resolving symbol: " + symbolName);
                            onResolveErrorCallback("unknown_symbol");
                        }
                    }, 10);
                }
            }
        },
        {
            /**
   * 搜索商品
   * @param {*String 用户在商品搜索框中输入的文字} userInput
   * @param {*String 请求的交易所（由用户选择）。空值表示没有指定} exchange
   * @param {*String 请求的商品类型：指数、股票、外汇等等（由用户选择）。空值表示没有指定} symbolType
   * @param {*Function 回调函数} onResultReadyCallback
   */ key: "searchSymbols",
            value: function searchSymbols(userInput, exchange, symbolType, onResultReadyCallback) {
                if (this._configuration.supports_search) {
                    console.log(" >> 搜索商品：", userInput, exchange, symbolType);
                    // step 1：向服务端发起请求
                    // your code
                    // step 2：返回结果
                    onResultReadyCallback([
                        // https://b.aitrade.ga/books/tradingview/book/JS-Api.html#searchSymbolsuserinput-exchange-symboltype-onresultreadycallback
                        {
                            symbol: "AAFR",
                            full_name: "BTCUSD",
                            description: "",
                            exchange: "",
                            ticker: "",
                            type: "stock" | "futures" | "bitcoin" | "forex" | "index"
                        }, 
                    ]);
                }
            }
        },
        {
            /**
   * 获取时间刻度
   * @param {*Object 商品信息} symbolInfo
   * @param {*Number unix时间戳 (UTC)} startDate
   * @param {*Number unix时间戳 (UTC)} endDate
   * @param {*Function 回调函数} onDataCallback
   * @param {*String 分辨率} resolution
   */ key: "getTimescaleMarks",
            value: function getTimescaleMarks(symbolInfo, startDate, endDate, onDataCallback, resolution) {
                if (this._configuration.supports_timescale_marks) {
                    // console.log(' >> 获取时间刻度：', symbolInfo, startDate, endDate, resolution)
                    // step 1：向服务端发起请求
                    // your code
                    // step 2：返回结果
                    onDataCallback([]);
                }
            }
        },
        {
            /**
   * 获取K线标记
   * @param {*Object 商品信息} symbolInfo
   * @param {*Number unix时间戳 (UTC)} startDate
   * @param {*Number unix时间戳 (UTC)} endDate
   * @param {*Function 回调函数} onDataCallback
   * @param {*String 分辨率} resolution
   */ key: "getMarks",
            value: function getMarks(symbolInfo, startDate, endDate, onDataCallback, resolution) {
                if (this._configuration.supports_marks) {
                    // console.log(' >> 获取K线标记：', symbolInfo, startDate, endDate, resolution)
                    // step 1：向服务端发起请求
                    // your code
                    // step 2：返回结果
                    onDataCallback([]);
                }
            }
        },
        {
            /**
   * 
   * @param {*Object 商品信息对象} symbolInfo 
   * @param {*String 周期} resolution 
  //  * @param {*Number 时间戳、最左边请求的K线时间} rangeStartDate
  //  * @param {*Number 时间戳、最右边请求的K线时间} rangeEndDate 
   * @param {*Object 具有以下字段的对象} periodParams
   *    ---@param {*Number 时间戳、最左边请求的K线时间} from
   *    ---@param {*Number 时间戳、最右边请求的K线时间} to
   *    ---@param {*Boolean 是否第一次调用此商品/周期的历史记录。当设置为true时 你可以忽略to参数} firstDataRequest
  //  * @param {*Function 回调函数} onDataCallback
   * @param {*Function 回调函数} onHistoryCallback
   * @param {*Function 回调函数} onErrorCallback
   */ // getBars(symbolInfo, resolution, rangeStartDate, rangeEndDate, onDataCallback, onErrorCallback, firstDataRequest) {
            key: "getBars",
            value: function getBars(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) {
                if (periodParams.rangeStartDate > 0 && String(periodParams.rangeStartDate).length > 10) {
                    throw new Error([
                        "Got a JS time instead of Unix one.",
                        periodParams.rangeStartDate,
                        periodParams.rangeEndDate
                    ]);
                }
                var onLoadedCallback = function onLoadedCallback(data) {
                    if (data) {
                        var nodata = data.noData || data.s === "no_data";
                        if (data.s !== "ok" && !nodata) {
                            if (typeof onErrorCallback === "function") {
                                onErrorCallback(data.s);
                            }
                            return;
                        }
                        var bars = data.bars || [];
                        onHistoryCallback(bars, {
                            noData: nodata,
                            nextTime: data.nextTime
                        });
                    } else {
                        console.warn("getBars(): error");
                        if (typeof onErrorCallback === "function") {
                            onHistoryCallback("error");
                        }
                    }
                };
                this._mgr.getBars(symbolInfo.ticker.toUpperCase(), resolution, periodParams, onLoadedCallback);
            }
        },
        {
            /**
   * 订阅K线数据
   * @param {*Object 商品信息对象} symbolInfo
   * @param {*String 分辨率} resolution
   * @param {*Function 回调函数} onRealtimeCallback
   * @param {*String 监听的唯一标识符} listenerGUID
   * @param {*Function 回调函数} onResetCacheNeededCallback
   */ key: "subscribeBars",
            value: function subscribeBars(symbolInfo, resolution, onRealtimeCallback, listenerGUID, onResetCacheNeededCallback) {
                // console.log('subscribeBars: ' + symbolInfo + ', ' + resolution + ', ' + listenerGUID);
                this._mgr.subscribeBars(symbolInfo, resolution, onRealtimeCallback, listenerGUID, onResetCacheNeededCallback);
            }
        },
        {
            /**
   * 取消订阅K线数据
   * @param {*String 监听的唯一标识符} listenerGUID
   */ key: "unsubscribeBars",
            value: function unsubscribeBars(listenerGUID) {
                this._mgr.unsubscribeBars(listenerGUID);
            }
        }
    ]);
    return Datafeeds;
}();
/* harmony default export */ var datafeed = (Datafeeds);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/tradeView/utils.js


function formatTimeInBarToMs(bar, resolution) {
    // console.log('方法', resolution, bar)
    var timezone = new Date().getTimezoneOffset() * 60 * 1000;
    var mstime = 0;
    if (resolution === "1D") {
        mstime = 57600000;
    } else if (resolution === "1W") {
        mstime = 576000000;
    } else if (resolution === "1M") {
        mstime = 2563200000;
    }
    if (resolution === "1D" || resolution === "1W" || resolution === "1M") {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bar), {
            // time: bar.time,
            time: bar.time + mstime + timezone
        });
    }
    return (0,_object_spread/* default */.Z)({}, bar);
}

;// CONCATENATED MODULE: ./src/tradeView/index.js
/* eslint-disable */ // import { widget } from '../../../public/charting_library';




// import { UDFCompatibleDatafeed } from '../../../public/datafeeds/udf/lib/udf-compatible-datafeed';
/* harmony default export */ var tradeView = ({
    queryData: {},
    tvWidget: null,
    dataFeed: null,
    dataCache: {},
    getBarTimer: null,
    resolution: null,
    realtimeCallback: {},
    isSubscribe: false,
    init: function init(options, callback) {
        this.dataCache = {};
        this.isSubscribe = false;
        this.queryData = options;
        this.resolution = options.interval;
        // this.dataFeed = new UDFCompatibleDatafeed(this)
        this.dataFeed = new datafeed(this);
        var widgetConfig_defalut = {
            debug: false,
            autosize: true,
            // toolbar_bg: true,
            // fullscreen: true,
            // symbol: options.symbol,
            symbol: options.name,
            interval: options.interval,
            container: options.container,
            datafeed: this.dataFeed,
            // library_path: '/charting_library/', // 包文件路径
            library_path: "/static/charting_library/",
            // library_path: 'https://defibox1.s3.ap-northeast-1.amazonaws.com/charting_library/',
            timezone: "Asia/Shanghai",
            // timezone: 'Etc/UTC',
            // 开启功能
            enabled_features: [
                // 'keep_left_toolbar_visible_on_small_screens',
                "side_toolbar_in_fullscreen_mode",
                "hide_left_toolbar_by_default",
                "left_toolbar",
                // 'header_indicators',
                // 'show_left_toolbar_by_default',
                "keep_left_toolbar_visible_on_small_screens",
                // 'hide_last_na_study_output', // 隐藏最后一次指标输出
                "move_logo_to_main_pane",
                // 'dont_show_boolean_study_arguments', // 隐藏指标参数
                "show_zoom_and_move_buttons_on_touch",
                // 'header_widget_dom_node',
                // 'main_series_scale_menu',
                // 'save_chart_properties_to_local_storage',
                "show_interval_dialog_on_key_press", 
            ],
            // 关闭功能
            disabled_features: [
                // 'control_bar', // 底部的导航按钮(选择时间周期隐藏)
                "timeframes_toolbar",
                // 'main_series_scale_menu', // 隐藏图表右下角的设置按钮
                "symbol_search_hot_key",
                "header_widget_dom_node",
                "header_symbol_search",
                "header_resolutions",
                // 'header_interval_dialog_button',
                // 'show_interval_dialog_on_key_press',
                // 'header_chart_type', // 隐藏图表类型切换
                // 'header_settings',
                // 'header_indicators', // 各种指标功能入口
                "header_compare",
                "header_undo_redo",
                // 'header_screenshot', // 下载图片
                "header_fullscreen_button",
                "volume_force_overlay", 
            ],
            studies_overrides: {
                // 'paneProperties.legendProperties.showLegend': false,
                "volume.precision": 0
            },
            // supported_resolutions:['5',"15","30","60",'240',"D","W","M"],
            custom_formatters: {
                priceFormatterFactory: function(symbolInfo, minTick) {
                    return {
                        format: function(price, signPositive) {
                            if (price >= 1) {
                                return Number(price).toFixed(4);
                            } else {
                                // console.log('price', price)
                                price = Number(price.toString()).toFixed(18).toString();
                                var priceVal = price.toString().split(".")[1] || "0.00";
                                var indexOfs = priceVal.indexOf("0");
                                var returnValue = "";
                                var nums = 0;
                                var forConti = true;
                                for(var i = 0; i < priceVal.length; i++){
                                    var iNumber = Number(priceVal[i]);
                                    var iNumber1 = Number(priceVal[i + 1]);
                                    if (indexOfs === 0 && forConti) {
                                        if (iNumber === 0 && iNumber1 === 0) {
                                            nums++;
                                        } else {
                                            forConti = false;
                                        }
                                    }
                                }
                                if (nums > 3 && indexOfs === 0) {
                                    returnValue = "0.".concat(priceVal.slice(0, indexOfs + 1), "{").concat(nums + 1, "}").concat(priceVal.slice(nums + 1, nums + 4));
                                } else if ((nums === 2 || nums === 3) && indexOfs === 0) {
                                    returnValue = Number(price).toFixed(8);
                                } else {
                                    returnValue = Number(price).toFixed(4);
                                }
                                return returnValue;
                            }
                        }
                    };
                }
            }
        };
        // console.log('widget', widget)
        // const container = this.$refs.chartContainer;
        // console.log('container', container)
        var widgetConfig = Object.assign(widgetConfig_defalut, options.wgconfig);
        var tvWidget = new s(widgetConfig);
        this.tvWidget = tvWidget;
        // console.log('this.tvWidget', this.tvWidget)
        this.resetData();
        callback();
    },
    resetData: function resetData() {
        this.dataFrom = 0;
        this.noMoreData = false;
        this.isSubscribe = false;
    },
    // getBars: function (symbol, resolution, from, to, callback, firstDataRequest) {
    getBars: function getBars(symbol, resolution, periodParams, callback) {
        var _this = this;
        // console.log(store.state.app.klineConfig.interval, callback);
        var res = this.resolution //todo: bug, this.resolution != resolution
        ;
        // console.log('from:' + (new Date(from * 1000).toISOString().slice(0,19)));
        // console.log('to:' + (new Date(to * 1000).toISOString().slice(0,19)));
        // console.log('当前' + this.resolution, periodParams);
        if (this.noMoreData) {
            callback && callback({
                s: "no_data"
            });
            return;
        }
        if (this.dataFrom > 0 && periodParams.to > this.dataFrom) {
            periodParams.to = this.dataFrom;
        }
        if (periodParams.from >= periodParams.to) {
            callback && callback({
                s: "ok",
                bars: []
            });
            return;
        }
        // 请求数据
        var params = {
            resolution: res,
            // resolutions: interval,
            symbol: this.queryData.ticker,
            pairId: this.queryData.pairId,
            from: periodParams.from,
            to: periodParams.to
        };
        // 请求并callback
        // Io.cfwsKline(client, params, KLineTime, true, (response, way) => {
        socket.cfwsKline(params, !this.isSubscribe, function(response, way) {
            _this.isSubscribe = true;
            if (way == "all") {
                _this.dataFrom = periodParams.from;
                if (response.klines.length == 0) {
                    _this.noMoreData = true;
                    callback && callback({
                        s: "no_data"
                    });
                } else {
                    var bars = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = response.klines[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            var barTime = element.time / 1000;
                            if (barTime >= periodParams.from && barTime <= periodParams.to) {
                                bars.push(element);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    bars.sort(function(l, r) {
                        return l.time > r.time ? 1 : -1;
                    });
                    // callback && callback({ s: 'ok', bars: bars })
                    callback && callback({
                        s: "ok",
                        bars: bars.map(function(bar) {
                            return formatTimeInBarToMs(bar, resolution);
                        })
                    });
                }
            } else {
                var listenerGUID = symbol.toLowerCase() + "_#_" + _this.resolution.toLowerCase();
                var _listenerGUID = listenerGUID.replace("+", "_");
                var realtimeCallback = _this.realtimeCallback[_listenerGUID];
                if (typeof realtimeCallback == "function") {
                    realtimeCallback(response.klines[0]);
                }
            }
        });
    },
    subscribeBars: function subscribeBars(symbolInfo, resolution, onRealtimeCallback, listenerGUID, onResetCacheNeededCallback) {
        var _listenerGUID = listenerGUID.replace("+", "_").toLowerCase();
        this.realtimeCallback[_listenerGUID] = onRealtimeCallback;
    // console.log(this.realtimeCallback);
    },
    unsubscribeBars: function unsubscribeBars(listenerGUID) {
        var _listenerGUID = listenerGUID.replace("+", "_").toLowerCase();
        delete this.realtimeCallback[_listenerGUID];
    },
    // 设置配置信息
    getConfig: function getConfig() {
        // https://b.aitrade.ga/books/tradingview/book/UDF.html
        return {
            supports_search: true,
            supports_group_request: false,
            supports_marks: true,
            supports_timescale_marks: true,
            supports_time: true,
            supported_resolutions: [
                "5",
                "15",
                "30",
                "60",
                "240",
                "1D",
                "1W",
                "1M"
            ]
        };
    },
    // 默认配置信息
    resolveTVSymbol: function resolveTVSymbol(symbol) {
        // https://b.aitrade.ga/books/tradingview/book/Symbology.html
        // console.log('this.queryData', this.queryData)
        var pairIdList = [
            "0xed49d7719d7da326529d45ae5e952225ce8c00ea",
            "0xf9788697de52f56c998764d356e5cb86dc43a6ad"
        ];
        return {
            name: this.queryData.name,
            // 'exchange': 'Newdex',
            // 'data_status': 'streaming',
            data_status: "streaming",
            "exchange-traded": "",
            "exchange-listed": "",
            timezone: "Asia/Shanghai",
            minmov: 1,
            minmov2: 0,
            pointvalue: "",
            fractional: false,
            session: "24x7",
            has_intraday: true,
            has_no_volume: false,
            description: this.queryData.name,
            pricescale: this.queryData.pricescale,
            // pricescale:
            //   this.queryData.pairId == '0xed49d7719d7da326529d45ae5e952225ce8c00ea' ? 10 ** 13 : this.queryData.pricescale, // 保留小数位数 10000 4位
            ticker: this.queryData.ticker,
            has_weekly_and_monthly: true
        };
    },
    getServerTime: function getServerTime() {
        // 暂时由客户端生成时间
        return parseInt(Date.now() / 1000);
    },
    /*
   * 生成日期分辨率按钮
   * @params name 名称
   * @params active 是否选中
   * @params resolution [1, 5, 15, 30, 60, 1D, 1W]
   */ createdDataBtn: function createdDataBtn(name, active, resolution) {
        var _this = this;
        var widget = _this.tvWidget;
        // const buttonEvent = widget.createButton();
        var button = widget.createButton();
        // const button = buttonEvent[0];
        var className = "button";
        // button.innerHTML = button.title = name;
        button.innerHTML = name;
        if (active) className = "button selected";
        button.className = className;
        button.onclick = function() {
            _this.resolution = resolution;
            _this.resetData();
            // const parent = button.parentNode.parentNode;
            var parent = button.parentNode.parentNode.parentNode;
            var children = parent.getElementsByClassName("button");
            for(var i = 0; i < children.length; i++){
                children[i].className = "button";
            }
            button.className = "button selected";
            widget.chart().setResolution(resolution, function onReadyCallback() {
            // console.log('resolution', resolution)
            // const klineConfig = _this.queryData.self.$store.state.app.klineConfig;
            // const klineConfig = localStorage.getItem('kline');
            // klineConfig.interval = resolution;
            // _this.queryData.self.$store.dispatch('setKlineConfig', klineConfig);
            // localStorage.setItem('kline', resolution)
            });
        };
    },
    /*
   * 全屏按钮
   */ createdFillWinBtn: function createdFillWinBtn() {
        var _this = this;
        var widget = _this.tvWidget;
        var buttonEvent = widget.createButton({
            align: "right"
        });
        // const button = buttonEvent[0];
        var button = buttonEvent;
        window.fullscreenBtnEvent = buttonEvent;
        // button.title = _this.queryData.self.$t('nav.fullScreen');
        button.title = "全屏";
        button.className = "button fullscreen iconed apply-common-tooltip";
        button.id = "fullscreenBtn";
        var img = document.createElement("img");
        img.src = "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/fullscreen1.png";
        img.alt = "FullScreen";
        img.className = "fullscreen";
        buttonEvent.append(img);
        button.onclick = function() {
            var tvid = document.getElementById("tv_chart_container");
            if (tvid.className === "tv_chart_container_full") {
                tvid.className = "";
                // document.exitFullscreen()
                if (document.exitFullscreen) {
                    document.exitFullscreen() // 标准退出全屏方法
                    ;
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen() // iOS Safari
                    ;
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen() // Firefox
                    ;
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen() // IE11
                    ;
                }
                button.innerHTML = "";
                button.title = "全屏";
                buttonEvent.append(img);
                return;
            }
            tvid.className = "tv_chart_container_full";
            // console.log('tvid', tvid)
            // tvid.requestFullscreen()
            if (tvid.requestFullscreen) {
                tvid.requestFullscreen() // 其他浏览器
                ;
            } else if (tvid.webkitRequestFullscreen) {
                tvid.webkitRequestFullscreen() // Safari 和 iOS Safari
                ;
            } else if (tvid.webkitEnterFullscreen) {
                tvid.webkitEnterFullscreen() // iOS Safari
                ;
            } else if (tvid.msRequestFullscreen) {
                tvid.msRequestFullscreen() // IE11
                ;
            }
            button.innerHTML = "";
            button.title = "离开全屏";
            buttonEvent.append(img);
        };
    },
    /*
   * k 线按钮
   */ createdKlineBtn: function createdKlineBtn() {
        var _this = this;
        var widget = _this.tvWidget;
        var buttonEvent = widget.createButton({
            align: "right"
        });
        var button = buttonEvent[0];
        button.className = "button selected iconed apply-common-tooltip";
        button.id = "kLineBtn";
        buttonEvent.append('<span class="klinebtn">' + _this.queryData.self.$t("tv.kline") + "<span/>");
    },
    /*
   * 深度按钮
   */ createdDepthBtn: function createdDepthBtn(callback) {
        var _this = this;
        var widget = _this.tvWidget;
        var buttonEvent = widget.createButton({
            align: "right"
        });
        var button = buttonEvent[0];
        window.depthBtnEvent = buttonEvent;
        button.className = "button iconed apply-common-tooltip";
        button.id = "depthBtn";
        buttonEvent.append('<span class="depthBtn">' + _this.queryData.self.$t("tv.pool") + "<span/>");
        button.onclick = function() {
            callback();
        };
    },
    /*
   * 语言更换
   */ tvSetLanguage: function tvSetLanguage(lang) {
        var _this = this;
        var widget = _this.tvWidget;
        widget.setLanguage(lang);
    }
});

;// CONCATENATED MODULE: ./src/views/Info/components/InfoCharts/KlineChart/index.tsx
/* eslint-disable */ 






// import Io from 'socket/index2.js';

var TVChartContainerComponent = function(_param) {
    var handleFormatLang = function handleFormatLang(val) {
        // console.log(val, '语言调整')
        var lang = val;
        if (lang === "zh-TW") {
            lang = "zh_TW";
        }
        if (lang === "en-US") {
            lang = "en";
        }
        if (lang === "zh-CN") {
            lang = "zh_TW";
        }
        if (lang === "ko-KR") {
            lang = "en";
        }
        // return lang;
        setLang(lang);
    };
    var handleLoadTradingView = // 修改设定的订阅时间
    function handleLoadTradingView(val) {
        // console.log('方法已执行', val)
        var theme_str = "white";
        var tvid = document.getElementById("tv_chart_container");
        // console.log('容器', tvid)
        var params = {
            // interval: val || interval, // 分辨率（时间周期）
            // interval: 'day',
            interval: interval,
            wgconfig: handleGetThemeConfig(theme_str),
            // self: this,
            container: tvid
        };
        // console.log(params, '修改设定的订阅时间')
        if (forwhat === "kline") {
            var ref, ref1;
            params = Object.assign(params, {
                // name: '0x2a3b2d64960036de519dc4a45cafd532bfa99ff0', // k线显示的交易对
                // ticker: '0x2a3b2d64960036de519dc4a45cafd532bfa99ff0', // 后台请求币种对
                name: poolData === null || poolData === void 0 ? void 0 : (ref = poolData.token0) === null || ref === void 0 ? void 0 : ref.address,
                ticker: poolData === null || poolData === void 0 ? void 0 : (ref1 = poolData.token0) === null || ref1 === void 0 ? void 0 : ref1.address,
                pricescale: Math.pow(10, 18),
                pairId: poolData === null || poolData === void 0 ? void 0 : poolData.address
            });
            tradeView.init(params, function() {
                // console.log('初始化成功')
                handleChartReady();
            });
        }
    };
    var handleGetThemeConfig = // 获取主题
    function handleGetThemeConfig(str) {
        var themeobj = {
            black: {
                locale: lang,
                custom_css_url: "/static/theme/black.css",
                toolbar_bg: "#152247",
                // 加载背景色, 加载条颜色
                loading_screen: {
                    backgroundColor: "#152247",
                    foregroundColor: "#fff"
                },
                overrides: {
                    "paneProperties.background": "#152247",
                    "paneProperties.vertGridProperties.color": "RGBA(153, 153, 156, 0.1)",
                    "paneProperties.horzGridProperties.color": "RGBA(153, 153, 156, 0.1)",
                    "scalesProperties.textColor": "#AAA"
                }
            },
            white: {
                locale: lang,
                custom_css_url: "/static/theme/white.css",
                toolbar_bg: "#fff",
                // 加载背景色, 加载条颜色
                // loading_screen: { backgroundColor: '#fff', foregroundColor: 'RGBA(0, 148, 213, 1)' },
                overrides: {
                    "paneProperties.background": "#ffffff",
                    "paneProperties.vertGridProperties.color": "RGBA(153, 153, 156, 0.18)",
                    "paneProperties.horzGridProperties.color": "RGBA(153, 153, 156, 0.18)",
                    "scalesProperties.textColor": "#333"
                }
            }
        };
        var overrides = {
            // "mainSeriesProperties.candleStyle.upColor": "#14A670", // 涨、蜡烛图的颜色
            // "mainSeriesProperties.candleStyle.downColor": "#F83F3F", // 跌、蜡烛图的颜色
            "mainSeriesProperties.candleStyle.drawBorder": true,
            "mainSeriesProperties.candleStyle.borderUpColor": "#40A771",
            "mainSeriesProperties.candleStyle.borderDownColor": "#E53A48",
            "mainSeriesProperties.candleStyle.wickUpColor": "#40A771",
            "mainSeriesProperties.candleStyle.wickDownColor": "#E53A48",
            volumePaneSize: "medium",
            "timeScale.rightOffset": 2,
            toggleButton: {
                background: "#FF0000",
                text: "#FFFFFF"
            },
            // "paneProperties.legendProperties.showLegend": false, // 是否显示 交易对和分辨率（时间周期）
            // "paneProperties.legendProperties.showSeriesTitle": true, // // 是否显示 交易对和分辨率（时间周期）
            "paneProperties.legendProperties.showStudyArguments": false,
            "paneProperties.legendProperties.showStudyTitles": true,
            "paneProperties.legendProperties.showStudyValues": true,
            "mainSeriesProperties.lineStyle.color": "#6ba583",
            "scalesProperties.fontSize": 11,
            "paneProperties.horzGridProperties.style": 1,
            "paneProperties.vertGridProperties.style": 1
        };
        themeobj.white.overrides = Object.assign(themeobj.white.overrides, overrides);
        themeobj.black.overrides = Object.assign(themeobj.black.overrides, overrides);
        return themeobj[str];
    };
    var handleChartReady = // 准备初始化图表
    function handleChartReady() {
        if (setValue) setValue(undefined);
        if (setLabel) setLabel(undefined);
        // const _this = this;
        tradeView.tvWidget.onChartReady(function() {
            tradeView.tvWidget.headerReady().then(function() {
                // Tv.createdDataBtn(this.$t('tv.minute'), this.interval === '1', '1');
                tradeView.createdDataBtn(t("noah480"), interval === "5", "5");
                tradeView.createdDataBtn(t("noah215"), interval === "15", "15");
                // Tv.createdDataBtn(t('noah214'), interval === '30', '30');
                tradeView.createdDataBtn(t("noah214"), interval === "60", "60");
                tradeView.createdDataBtn(t("noah197"), interval === "240", "240");
                tradeView.createdDataBtn(t("noah198"), interval === "1D", "1D");
                tradeView.createdDataBtn(t("noah199"), interval === "1W", "1W");
                tradeView.createdDataBtn(t("noah200"), interval === "1M", "1M");
                tradeView.createdFillWinBtn();
            });
        // Tv.tvWidget.activeChart().crossHairMoved().subscribe(null,({ time, price }) => {
        //   console.log(time, price)
        //   const timestamp = time as number
        //   const now = new Date(timestamp)
        //   const times = `${now.toLocaleString(lang, {
        //     year: 'numeric',
        //     month: 'short',
        //     day: 'numeric',
        //     // hour: 'numeric',
        //     // minute: '2-digit',
        //     timeZone: 'UTC',
        //   })}`
        //   if (setValue) setValue(formatNumber(formatPrice(price), price))
        //   if (setLabel) setLabel(times)
        // });
        });
    // this.loading = false;
    };
    var handleTradViewUnsubscribe = // 取消订阅
    function handleTradViewUnsubscribe() {
        var type = "minute";
        var resolution = interval.toString();
        if (resolution === "5") {
            type = "minute5";
        } else if (resolution === "15") {
            type = "minute15";
        } else if (resolution === "30") {
            type = "minute30";
        } else if (resolution === "60") {
            type = "hour";
        } else if (resolution === "240") {
            type = "hour4";
        } else if (resolution === "1D") {
            type = "day";
        } else if (resolution === "1W") {
            type = "week";
        } else if (resolution === "1M") {
            type = "month";
        }
        if ((poolData === null || poolData === void 0 ? void 0 : poolData.address) && forwhat === "kline") {
            var env = "production";
            var uri = "wss://api.noahark.io/aws";
            var BASE_URL = "api.noahark.io";
            if (true) {
                BASE_URL =  true ? window.location.hostname : 0;
            }
            uri = "wss://" + BASE_URL + "/aws";
            if (false) {}
            console.log("wss-URL", uri);
            var client = new cfws({
                env: env,
                uri: uri,
                debug: false
            });
            socket.cfwsUnsubscribe(client);
            // Io.cfwsUnsubscribe(`kline.${type}.${poolData?.address}`)
            // Io.cfwsUnsubscribe()
            return;
        }
    };
    var data = _param.data, setValue = _param.setValue, setLabel = _param.setLabel, poolData = _param.poolData, _kLoading = _param.kLoading, kLoading = _kLoading === void 0 ? false : _kLoading, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "data",
        "setValue",
        "setLabel",
        "poolData",
        "kLoading"
    ]);
    var t = (0,src/* useTranslation */.$G)() // language code
    .t;
    var codeFromStorage = (0,src/* getLanguageCodeFromLS */.jq)() // current language code
    ;
    // console.log('当前缓存的语言', codeFromStorage)
    // console.log('data传值', data)
    // console.log('poolData传值', poolData)
    var currentLanguage;
    if (codeFromStorage === "zh-TW") {
        currentLanguage = "zh_TW";
    }
    if (codeFromStorage === "en-US") {
        currentLanguage = "en";
    }
    if (codeFromStorage === "zh-CN") {
        currentLanguage = "zh_TW";
    }
    if (codeFromStorage === "ko-KR") {
        currentLanguage = "en";
    }
    var chartContainerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(currentLanguage), lang = ref[0], setLang = ref[1];
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var isMobile = isDesktop === false;
    var ref1 = (0,react.useState)(true), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)(""), theme = ref2[0], setTheme = ref2[1];
    var ref3 = (0,react.useState)(""), tradName = ref3[0], setTradName = ref3[1];
    var ref4 = (0,react.useState)(""), ticker = ref4[0], setTicker = ref4[1];
    var ref5 = (0,react.useState)(null), symTrad = ref5[0], setSymTrad = ref5[1];
    var ref6 = (0,react.useState)("60"), interval = ref6[0], setInterval = ref6[1];
    // const [pairId, setPairId] = useState('0xf00a9f9c3e986d42429cc79c1baf5dacdffbc9a2');
    var ref7 = (0,react.useState)("kline"), forwhat = ref7[0], setForwhat = ref7[1];
    var ref8 = (0,react.useState)({}), poolInfo = ref8[0], setPoolInfo = ref8[1];
    var tvChartContainerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (poolData.address) {
            // console.log('池子id', poolData.address)
            handleFormatLang(codeFromStorage);
            // console.log('当前语言', lang)
            handleLoadTradingView();
        }
    // poolData
    }, [
        codeFromStorage,
        poolData.address,
        lang
    ]) // 注意，这里的空数组[]确保useEffect只在组件挂载时运行一次
    ;
    (0,react.useEffect)(function() {
        return function() {
            // console.log('我离开了~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
            handleTradViewUnsubscribe();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            height: isMobile ? "370px" : "500px",
            position: "relative",
            paddingBottom: "20px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                height: "100%"
            },
            id: "tv_chart_container",
            className: "TVChartContainer",
            ref: chartContainerRef
        })
    });
};
/* harmony default export */ var KlineChart = (TVChartContainerComponent);


/***/ })

}]);